
import store from '../../config/store'

export default {
  data: () => ({
    store,
    dropdown: false,
    reason: '',
  }),

  methods: {
    onCloseModal () {
      store.modal.active = false
    },

    onValidateReason () {
      this.$bus.$emit('on-validate-reject-reason', this.reason)
    }
  }
}
